module.exports = __webpack_public_path__ + "/images/cover-fr-recibiendo-dinero-es.c68addc.jpg";